import { gql, MutationHookOptions, useMutation } from "@apollo/client";

import { ReportFragment, REPORT_FRAGMENT } from "../../fragments";
import { UpdateReportMutationVariables } from "../../types";

export const UPDATE_REPORT = gql`
  mutation updateReport($input: UpdateReportInput!) {
    updateReport(input: $input) {
      report {
        ...ReportFragment
      }
    }
  }
  ${REPORT_FRAGMENT}
`;

export type ReportData = { updateReport: { report: ReportFragment } };

export default (
  options?: MutationHookOptions<ReportData, UpdateReportMutationVariables>
) => {
  return useMutation<ReportData, UpdateReportMutationVariables>(
    UPDATE_REPORT,
    options
  );
};
